import * as React from 'react';

import * as styles from './objectFactoids.css';

export const ObjectFactoids = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className={styles['container']}>{children}</div>;
};
